import { render, staticRenderFns } from "./ai-greeting.vue?vue&type=template&id=0aa5b2dd&scoped=true"
import script from "./ai-greeting.vue?vue&type=script&lang=js"
export * from "./ai-greeting.vue?vue&type=script&lang=js"
import style0 from "./ai-greeting.vue?vue&type=style&index=0&id=0aa5b2dd&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa5b2dd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/AI合规前端-测试/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0aa5b2dd')) {
      api.createRecord('0aa5b2dd', component.options)
    } else {
      api.reload('0aa5b2dd', component.options)
    }
    module.hot.accept("./ai-greeting.vue?vue&type=template&id=0aa5b2dd&scoped=true", function () {
      api.rerender('0aa5b2dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/compliance/home/chat/ai-greeting.vue"
export default component.exports